/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-12-06
 * @brief EHP WorkOrder 컴포넌트
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
//
import { useAsync } from "react-async";
// recoli & state
import { useRecoilValue, useRecoilState } from "recoil";
import { userInfoLoginState, } from '../../../recoil/userState';
import { urlState, czoneInfoState } from "../../../recoil/menuState";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
//
import { useTrans } from "../../../utils/langs/useTrans";
import { useNavigate } from "react-router-dom";
/**
 * @brief EHP WorkOrder 컴포넌트, 반응형 동작
 * @param param0 width:<number>: 화면(브라우저) 가로 사이즈
 * @param param1 height:<number>: 화면(브라우저) 세로 사이즈
 * @returns react components
 */
function WorkOrder(props) {
    //t
    const t = useTrans();
    //trans, ref, navigate
    const navigate = useNavigate();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const [czoneInfo, setRecoilCZoneInfo] = useRecoilState(czoneInfoState);
    //
    //props
    const { company, zone, subZone, room, spg } = props.curTreeData;
    const statusReload = props.statusReload;
    //
    const [WorkorderItem, setWorkorderItem] = useState(null);
    const { data: data, error, isLoading, reload, run } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: "/api/v2/product/company/zone/subzone/room/workorder/count",
        appQuery: {
            //companyId: company.companyId, 
            //zoneId: zone.zoneId,
            roomId: room.roomId,
            spgName: spg.spgName
        },
        userToken: userInfo.loginInfo.token,
        watch: room.roomId + spg.spgName + statusReload,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setWorkorderItem(data.body);
            }
            else {
                alert(data.errorList.map((err) => (err.msg)));
            }
        }
    }, [data, spg]);
    function onClickGoLink(url) {
        setRecoilCZoneInfo({ company: company, zone: zone });
        setRecoilUrlInfo(url);
        navigate(url);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("article", { className: "box" },
            React.createElement("div", { className: "box__header" },
                React.createElement("p", { className: "box__title" }, "Work Order"),
                React.createElement("div", { className: "box__etc" },
                    React.createElement("button", { type: "button", className: "btn btn-go", onClick: e => onClickGoLink(CONST.URL_SERVICEWORKORDER) },
                        React.createElement("span", { className: "hide" }, "\uBC14\uB85C\uAC00\uAE30")))),
            (WorkorderItem) &&
                React.createElement("div", { className: "box__body" },
                    React.createElement("div", { className: "box__status" },
                        React.createElement("ul", { className: "status__info" },
                            React.createElement("li", null,
                                React.createElement("p", null, room.roomName + " / " + spg.spgName),
                                React.createElement("p", null,
                                    React.createElement("strong", null, WorkorderItem.totalCount),
                                    React.createElement("span", null, t("LABEL.개"))))),
                        React.createElement("p", { className: "txt-info mt-6 ml-15 mr-20 mb-52" }, "* Work Order\uB294 LS\uC77C\uB809\uD2B8\uB9AD\uC758 Engineer\uC5D0\uAC8C e-HC [Premium] , [Advanced] \uC810\uAC80\uC744 \uC694\uCCAD\uD55C \uB0B4\uC5ED\uB9CC \uD45C\uC2DC\uB429\uB2C8\uB2E4."),
                        React.createElement("ul", { className: "step-order" },
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, t("LABEL.요청")),
                                React.createElement("p", { className: "total-num" },
                                    React.createElement("strong", null, WorkorderItem.requestCount),
                                    React.createElement("span", null, " ea"))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, t("LABEL.접수")),
                                React.createElement("p", { className: "total-num" },
                                    React.createElement("strong", null, WorkorderItem.acceptedCount),
                                    React.createElement("span", null, " ea"))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, t("LABEL.진행중")),
                                React.createElement("p", { className: "total-num" },
                                    React.createElement("strong", null, WorkorderItem.ingCount),
                                    React.createElement("span", null, " ea"))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, t("LABEL.완료")),
                                React.createElement("p", { className: "total-num" },
                                    React.createElement("strong", null, WorkorderItem.doneCount),
                                    React.createElement("span", null, " ea")))))))));
}
export default WorkOrder;
